import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import DefaultLayout from '../components/DefaultLayout'
import { Row, Col, Form, Tabs, Input, Button, Select, Checkbox, DatePicker } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { editTimeSheet } from '../redux/actions/timeSheetActions'
import moment from 'moment';
import TimeDropDown from '../components/TimeDropDown'

const { TabPane } = Tabs;

const { Option } = Select;

function EditTimeSheet({ match }) {

  const { timeSheets } = useSelector(state => state.timeSheetReducer)

  const timeSheet = timeSheets.find(ts => ts._id == match.params.id)

  const [timeSheetInfo, setTimeSheetInfo] = useState({})
  const [activeTab, setActiveTab] = useState("0")

  const dispatch = useDispatch()
  const allworkers = useSelector(state => state.workersReducer).workers;
  const allsites = useSelector(state => state.sitesReducer).sites;
  const history = useHistory()

  function onFinalFormFinish(values) {
    const finalObj = { ...timeSheetInfo, ...values };

    finalObj._id = match.params.id
    console.log(finalObj)
    dispatch(editTimeSheet(finalObj))
  }


  return (
    <div>
      <DefaultLayout>
        <Tabs defaultActiveKey='0' activeKey={activeTab}>
          <TabPane tab='Edit Time Sheet' key='0'>
            <Form onFinish={onFinalFormFinish} onReset={() => { history.push('/postedTimeSheet') }} >
              <Row>
                <Col lg={8} sm={24}>
                  <div>
                    <Form.Item name='appliedCandidate' label='Select Employees' valuePropName="option" initialValue={timeSheet.appliedCandidate}>
                      <Select
                        defaultValue={timeSheet.appliedCandidate}
                        className="mr-2"
                        style={{ minWidth: 200 }}

                      >
                        <Option value="0" disabled>-- Select Employee --</Option>
                        {allworkers.map(worker => {
                          return <Option value={worker.fname} key={worker.fname} >{worker.fname}</Option>
                        })}
                      </Select>
                    </Form.Item>

                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='date' rules={[{ required: true }]} label='Date' initialValue={moment(new Date(timeSheet.date), 'dddd, MMMM Do YYYY')}>
                    <DatePicker
                      format='dddd, MMMM Do YYYY'
                      defaultValue={moment(new Date(timeSheet.date), 'dddd, MMMM Do YYYY')}
                      style={{ width: 380 }}
                      className="mr-2"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='worksite' rules={[{ required: true }]} label='Worksite' initialValue={timeSheet.worksite} >
                    <Select
                      defaultValue={'0'}
                      className="mr-2"
                      style={{ minWidth: 200 }}
                    >
                      <Option value="0" disabled>-- Select Worksite --</Option>
                      {allsites.map(site => {
                        return <Option value={site.siteName} key={site['_id']} >{site.siteName}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <TimeDropDown name='stime' label='Start Time' defaultValue={timeSheet.stime} />
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <TimeDropDown name='etime' label='End Time' defaultValue={timeSheet.etime} />
                </Col>
              </Row>


              <Button htmlType='submit'>Submit</Button>
              <Button htmlType='reset' type="default" danger className="ml-2">Cancel</Button>
            </Form>
          </TabPane>

        </Tabs>
      </DefaultLayout>
    </div>
  )
}

export default EditTimeSheet
